$(document).ready(function () {

    GLightbox({
        selector: '.lightbox'
    });


    // =====================================================
    // DETAIL NÁCHOD
    // =====================================================
    if ($('.id-1039').length) {

        var map = L.map('map').setView([50.4174003, 16.1680222], 17);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap'
        }).addTo(map);

        var purpleIcon = L.icon({
            iconUrl: '/user/documents/upload/sablona/ico-purple.svg',
            iconSize: [38, 48],
            iconAnchor: [19, 48],
            popupAnchor: [0, -45]
        });

        L.marker([50.4174003, 16.1680222], {
            icon: purpleIcon
        }).addTo(map)
        /*.bindPopup(`
            <div class="map-popup">
                <strong>Prodejna Icedream Náchod</strong><br><br>
                
                <a href="tel:+420722901291">
                    +420 722 901 291
                </a><br>

                <a href="mailto:icedream@icedream.cz">
                    icedream@icedream.cz
                </a><br><br>

                <strong>Otevírací doba:</strong><br>
                dle před

                <a href="https://www.icedream.cz/centrala-nachod/"
                   target="_blank"
                   rel="noopener">
                    Detail prodejny
                </a>
            </div>
        `);*/
    }


    // =====================================================
    // DETAIL POBOČKY – DATA Z HTML
    // =====================================================
   /* else if ($('.id-1039').length) {

        var lat = parseFloat($('#mapDataLat').text());
        var lng = parseFloat($('#mapDataLng').text());

        var map = L.map('map').setView([lat, lng], 17);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap'
        }).addTo(map);

        L.marker([lat, lng]).addTo(map)
            .bindPopup($('h1').text());
    }
*/

    // =====================================================
    // HLAVNÍ MAPA – VŠECHNY POBOČKY A ZÁSTUPCI
    // =====================================================
    else {

        var map = L.map('map').setView([50.150991, 15.458205], 6);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap'
        }).addTo(map);


        // =================================================
        // IKONY
        // =================================================

        // FIALOVÁ
        // Prodejna / brusírna
        var purpleIcon = L.icon({
            iconUrl: '/user/documents/upload/sablona/ico-purple.svg',
            iconSize: [38, 48],
            iconAnchor: [19, 48],
            popupAnchor: [0, -45]
        });

        // RŮŽOVÁ
        // Obchodní zástupci
        var pinkIcon = L.icon({
            iconUrl: '/user/documents/upload/sablona/ico-pink.svg',
            iconSize: [38, 48],
            iconAnchor: [19, 48],
            popupAnchor: [0, -45]
        });

        // MODRÁ
        // Franšíza
        var blueIcon = L.icon({
            iconUrl: '/user/documents/upload/sablona/ico-blue.svg',
            iconSize: [38, 48],
            iconAnchor: [19, 48],
            popupAnchor: [0, -45]
        });


        // =================================================
        // FIALOVÁ – PRODEJNA NÁCHOD
        // =================================================

        L.marker([50.4167, 16.1656], {
            icon: purpleIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Prodejna Icedream Náchod</strong><br><br>

                Kamenice 91, Náchod 1<br>
                Pěší zóna – centrum města<br><br>

                <a href="tel:+420722901291">
                    +420 722 901 291
                </a><br>

                <a href="mailto:icedream@icedream.cz">
                    icedream@icedream.cz
                </a><br><br>

                <strong>Otevírací doba:</strong><br>
                Po–Pá: 9:00–17:00<br>
                So: 9:00–12:00<br>
                Ne: zavřeno<br><br>

                <a href="https://www.icedream.cz/centrala-nachod/"
                   target="_blank"
                   rel="noopener">
                    Detail prodejny
                </a>

            </div>
        `);


        // =================================================
        // FIALOVÁ – BRUSÍRNA PRAHA
        // =================================================

        L.marker([50.0676, 14.4536], {
            icon: purpleIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Brusírna Icedream Praha</strong><br>
                (Rada junior)<br><br>

                <em>Chystáme pro Vás</em>

            </div>
        `);


        // =================================================
        // RŮŽOVÁ – BŘECLAV
        // =================================================

        L.marker([48.7589, 16.8820], {
            icon: pinkIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Obchodní zástupce Břeclav</strong><br><br>

                <strong>Ing. Mirka Myslivečková</strong><br>

                <a href="tel:+420739555074">
                    +420 739 555 074
                </a><br>

                <a href="mailto:mirkamy@seznam.cz">
                    mirkamy@seznam.cz
                </a>

            </div>
        `);


        // =================================================
        // RŮŽOVÁ – HAVÍŘOV
        // =================================================

        L.marker([49.7798, 18.4369], {
            icon: pinkIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Obchodní zástupce Havířov</strong><br><br>

                <strong>Marcela Vlachová</strong><br>

                <a href="tel:+420602782374">
                    +420 602 782 374
                </a><br>

                <a href="mailto:marcela.havirov@seznam.cz">
                    marcela.havirov@seznam.cz
                </a>

            </div>
        `);


        // =================================================
        // RŮŽOVÁ – KARLOVY VARY
        // =================================================

        L.marker([50.2319, 12.8710], {
            icon: pinkIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Obchodní zástupce Karlovy Vary</strong><br><br>

                <strong>Bc. Anna Popová</strong><br>

                <a href="tel:+420777996482">
                    +420 777 996 482
                </a><br>

                <a href="mailto:icedream-karlovyvary@email.cz">
                    icedream-karlovyvary@email.cz
                </a>

            </div>
        `);


        // =================================================
        // MODRÁ – FRANŠÍZA PRAHA
        // =================================================

        L.marker([50.0755, 14.4378], {
            icon: blueIcon
        }).addTo(map)
        .bindPopup(`
            <div class="map-popup">

                <strong>Franšíza Praha</strong><br><br>

                <strong>Ing. Miloš Lauermann</strong><br>

                <a href="tel:+420608811414">
                    +420 608 811 414
                </a><br>

                <a href="mailto:wolf@wolf-gear.com">
                    wolf@wolf-gear.com
                </a>

            </div>
        `);

    }

});